import WebFont from 'webfontloader'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { QueryParamProvider } from 'use-query-params'

import { Loading, Toaster } from '@redriverpress/system'
import { ModalFoldersProvider } from 'Packages/folders'

import ElliiThemeProvider from 'Common/components/ElliiThemeProvider'
import { TWENTY_FOUR_HOURS_IN_MS } from 'Common/utils/datetime'

import MediaHeader from './common/components/MediaHeader'
import Routes from './Routes'
import { MediaGalleryProvider } from './contexts'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: TWENTY_FOUR_HOURS_IN_MS,
    },
  },
})

export default function App() {
  WebFont.load({
    google: {
      families: ['Open Sans:400,400italic,600,700,800', 'Quicksand:700'],
    },
  })

  return (
    <Router basename='/media'>
      <QueryClientProvider client={queryClient}>
        <ModalFoldersProvider fallback={<Loading />}>
          <QueryParamProvider ReactRouterRoute={Route}>
            <ElliiThemeProvider>
              <Toaster>
                <MediaHeader />
                <MediaGalleryProvider>
                  <Routes />
                </MediaGalleryProvider>
              </Toaster>
            </ElliiThemeProvider>
          </QueryParamProvider>
        </ModalFoldersProvider>
      </QueryClientProvider>
    </Router>
  )
}
